export default "__VITE_ASSET__BrekgPpd__"